import { Component } from '@angular/core';
import { NgbModalRef, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'lib-fw-horizontal-wrapper',
  templateUrl: './horizontal-wrapper.component.html',
  styleUrls: ['./horizontal-wrapper.component.scss'],
  imports: [NgbTooltip],
})
export class FormlyHorizontalWrapperComponent extends FieldWrapper {

  private modalRef: NgbModalRef;
  public window: Window;

  public constructor() {
    super();
    this.window = window;
  }

  public get labelIndentCssClass(): string {
    return this.props.labelIndent ? 'pl-5' : null;
  }

  public get expandCssClass() {
    return `fas fa-lg fa-${this.props.isExpanded() ? 'minus' : 'plus'}-circle pointer`;
  }

  public get expandText() {
    return this.props.isExpanded() ? this.props.closeText : this.props.openText;
  }

  public get colSize() {
    return this.field.parent.props['largerCol'] ||
      this.field.parent.parent.props['largerCol'] ? 'col-md-9' : 'col-md-6';
  }

  public toggleExpanded() {
    this.props.expandFunction();
  }

  public close() {
    this.modalRef.close();
  }
}
